import { render } from "./HandWorkUpdateModel.vue?vue&type=template&id=48222b2b"
import script from "./HandWorkUpdateModel.vue?vue&type=script&lang=js"
export * from "./HandWorkUpdateModel.vue?vue&type=script&lang=js"

import "./HandWorkUpdateModel.vue?vue&type=style&index=0&id=48222b2b&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__